export const memberPurchaseOrderStateEnum = [
    {
        stateId: "UNPAID",
        stateName: "待支付"
    },
    {
        stateId: "CANCELLED",
        stateName: "已取消"
    },
    {
        stateId: "CLOSED",
        stateName: "已关闭"
    },
    {
        stateId: "COMPLETED",
        stateName: "已完成"
    }
]
